import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { getDeviceId } from "@/lib/deviceId";
import { Cpu } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;

    const run = async () => {
      if (!sessionId) {
        navigate("/login");
        return;
      }
      try {
        const ref = localStorage.getItem("referral_code") || undefined;
        const device_id = await getDeviceId();
        const lang = localStorage.getItem("imperium-lang") || (navigator.language || "en").slice(0, 2);
        const { data } = await api.post("/auth/session", { session_id: sessionId, ref, device_id, lang });
        localStorage.removeItem("referral_code");
        setUser(data.user);
        window.history.replaceState({}, document.title, "/");
        navigate(data.user.role === "admin" ? "/admin" : "/client");
      } catch (e) {
        navigate("/login");
      }
    };
    run();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen grid place-items-center bg-ink-base text-white">
      <div className="flex flex-col items-center gap-4">
        <div className="w-14 h-14 grid place-items-center border border-aurora-cyan/40 rounded-sm bg-aurora-cyan/10 animate-pulse-glow">
          <Cpu className="w-7 h-7 text-aurora-cyan" />
        </div>
        <div className="font-mono text-xs tracking-widest uppercase text-zinc-400">
          Connexion sécurisée en cours...
        </div>
      </div>
    </div>
  );
};
